/**
 * Loads the current user's publish entitlement read model. Follows the
 * useState/useEffect data pattern used elsewhere in this SPA (no react-query).
 */
import { useCallback, useEffect, useState } from 'react';
import { fetchPublishEntitlement } from './api';
import type { PublishEntitlementView } from './types';

export interface UsePublishEntitlement {
  data: PublishEntitlementView | null;
  loading: boolean;
  error: string | null;
  reload: () => Promise<void>;
}

export function usePublishEntitlement(): UsePublishEntitlement {
  const [data, setData] = useState<PublishEntitlementView | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      setData(await fetchPublishEntitlement());
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load publishing rights.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void reload();
  }, [reload]);

  return { data, loading, error, reload };
}
